import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    height: auto;
    font-family: 'Poppins';
    background-color: #fff;
    margin-bottom: 50px;

    display: flex;

    flex-direction: column;
    align-items: center;
    padding: 50px;

    img {
      width: 200px;
    }

    .pesquisa {
      margin-top: 30px;
    }

    .consultant-note {
      max-width: 520px;
      text-align: center;
      color: #4b5563;
      margin: 8px 0 16px;
    }
  `}
`;

export const TrackLink = styled.button`
  ${({ theme }) => css`
    background: none;
    border: none;
    cursor: pointer;
    margin-top: 16px;
    color: ${theme.palette.primary.main};
    font-family: 'Poppins';
    font-size: 14px;
    text-decoration: underline;
  `}
`;
